export default __webpack_public_path__ + "static/media/technician_icon.0f1051ff.png";